import { c as _c } from "react/compiler-runtime";
import { IcoLock16 } from '@onefootprint/icons';
import { LinkButton, Shimmer } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useDocumentsQueryParams from '@/entity/hooks/use-documents-query-params';
type ItemValueProps = {
  isDecrypted: boolean;
  isDecrypting: boolean;
  documentId: string;
};
const ItemValue = t0 => {
  const $ = _c(11);
  const {
    isDecrypted,
    isDecrypting,
    documentId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset.documents"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const queryParams = useDocumentsQueryParams();
  if (isDecrypted) {
    let t2;
    if ($[1] !== documentId || $[2] !== queryParams) {
      t2 = () => {
        queryParams.push(documentId);
      };
      $[1] = documentId;
      $[2] = queryParams;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t) {
      t3 = t(_temp);
      $[4] = t;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== t2 || $[7] !== t3) {
      t4 = <LinkButton onClick={t2} className="text-accent hover:text-accent-hover text-label-2">{t3}</LinkButton>;
      $[6] = t2;
      $[7] = t3;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    return t4;
  }
  if (isDecrypting) {
    let t2;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Shimmer height="16px" width="90px" />;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    return t2;
  }
  let t2;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex items-center flex-shrink-0 gap-1"><IcoLock16 /><p className="text-body-2">•••••••••</p></div>;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};
export default ItemValue;
function _temp($) {
  return $.seeDetails;
}